import { MutationTree } from 'vuex';

import { setApiSession } from '@/api/client';

import { StateType } from './state';

const mutations: MutationTree<StateType> = {
  initState(state) {
    setApiSession({id: state.session?.userId,
      token: state.session? `${state.session.id}:${state.session.token}`: null});
  },
  setSession(state, newSession) {
    state.session = newSession;
    mutations.initState(state);
  },
  setProfile(state, newProfile) {
    state.profile = newProfile
  }
};

export default mutations;
